import React from "react";

type Props = {
  imageUrl: string | null;
  onClose: () => void;
};

const ImageModal: React.FC<Props> = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 16,
          right: 16,
          background: "none",
          border: "none",
          color: "white",
          fontSize: 30,
          cursor: "pointer",
          zIndex: 2001,
        }}
        aria-label="Close image"
      >
        &times;
      </button>

      <img
        src={imageUrl}
        alt="Full"
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).src =
            "https://placehold.co/800x600/CCCCCC/FFFFFF?text=Image+Not+Found";
        }}
        style={{
          maxHeight: "90vh",
          maxWidth: "95%",
          objectFit: "contain",
          borderRadius: 8,
          zIndex: 2000,
        }}
      />
    </div>
  );
};

export default ImageModal;
